var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavesInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.75px;}.cls-2{fill:#fff;}.cls-3{fill:#fffefd;}.cls-4{fill:#e6be8a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "faves-inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Favorito"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 6.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.86 16.75 14.93 27.06 26 16.75 24.12 16.75 14.93 25.3 5.84 16.75 3.86 16.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.58,11.5a9.62,9.62,0,0,0-2.12-3,6.69,6.69,0,0,0-3-1.67,5.56,5.56,0,0,0-3.28.26,6.4,6.4,0,0,0-2.64,2l-.66.84L14.21,9a6.61,6.61,0,0,0-2.69-2.21A5.49,5.49,0,0,0,8.1,6.51,6.64,6.64,0,0,0,5,8.28,9.73,9.73,0,0,0,2.82,11.5,8.05,8.05,0,0,1,4.33,7.74,7,7,0,0,1,7.75,5.25a6.56,6.56,0,0,1,4.37.12,8,8,0,0,1,3.42,2.71l-1.31,0a7.62,7.62,0,0,1,3.39-2.43,6.51,6.51,0,0,1,4.16,0A7,7,0,0,1,25.05,8,7.91,7.91,0,0,1,26.58,11.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.74,11.84h0l-.06,0a3.56,3.56,0,0,0,0,6.9,3.57,3.57,0,0,0,.08-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.2,11.62l-.09,0-.15,0a3.71,3.71,0,0,0-.67-.07,3.58,3.58,0,0,0-.87.11,3.7,3.7,0,0,1-.08,7.18h.05l.15,0a3.67,3.67,0,0,0,.75.08,3.71,3.71,0,0,0,.91-7.3Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavesInactive);
export default __webpack_public_path__ + "static/media/faves-inactive.4ce7d4fcc7de322dc6ad1377eb399e46.svg";
export { ForwardRef as ReactComponent };